module.exports = __webpack_public_path__ + "static/img/login-left.e36426b3.jpg";